export default __webpack_public_path__ + "da375b0a8b0ebbe2c81e7531084f5ff0.svg";